// TRS §7.3 — LT default, EN secondary. EUR only in v1, Europe/Vilnius timezone.
export const LOCALES = ['lt', 'en'];
export const DEFAULT_LOCALE = 'lt';
export const TIMEZONE = 'Europe/Vilnius';
export const CURRENCY = 'EUR';
//# sourceMappingURL=locales.js.map